import {Injectable} from '@angular/core';
import {
  HttpEvent,
  HttpInterceptor,
  HttpHandler,
  HttpRequest,
  HttpErrorResponse
} from '@angular/common/http';

import {Observable} from 'rxjs';
import {tap} from 'rxjs/operators';
import {Store} from '@ngrx/store';

import {environment as ENV} from '../../../environments/environment';
import {NotificationService} from '../../shared/services';
import {AppState} from '../core.state';
import {AlertController, Platform} from '@ionic/angular';
import {ActivatedRoute, Router} from '@angular/router';
import {TranslateService} from '@ngx-translate/core';
import {AuthActions} from '../stores/auth/actions';
import {ErrorReportService} from '../services';

export class V1ApiHttpErrorResponse extends HttpErrorResponse {
  // status: boolean;
  message: string;
  errorCode: string;
  exceptionTrace: any;
  request: any;
}

const WEBSERVICE_SESSION_EXPIRED = 'WEBSERVICE_SESSION_EXPIRED';
const WEBSERVICE_UNAUTHORIZED = 'WEBSERVICE_UNAUTHORIZED';
const WEBSERVICE_TOKEN_ERROR = 'WEBSERVICE_TOKEN_ERROR';
export const WEBSERVICE_APP_VERSION_ERROR = 'WEBSERVICE_APP_VERSION_ERROR';
const WEBSERVICE_GENERIC_ERROR = 'WEBSERVICE_FE_GENERIC_ERROR';

/** Passes HttpErrorResponse to application-wide error handler */
@Injectable()
export class V1HttpErrorInterceptor implements HttpInterceptor {

  // l'interceptor funziona solo per il valore apiUrl principale
  urlCheckRegex = new RegExp(`${ENV.apiUrl.replace('https://', '')}/${ENV.apiVersion}`);

  constructor(private notificationService: NotificationService,
              private platform: Platform,
              private router: Router,
              private route: ActivatedRoute,
              private alertController: AlertController,
              private translateService: TranslateService,
              private errorReportService: ErrorReportService,
              private store$: Store<AppState>) {
  }

  intercept(request: HttpRequest<any>, next: HttpHandler): Observable<HttpEvent<any>> {
    return next.handle(request).pipe(
      tap({
        error: (err: any) => {
          if (err instanceof HttpErrorResponse) {
            switch (true) {
              case (this.urlCheckRegex.test(request.url) === true):
                this.WebServiceErrorHandler(err.error);
                break;
              default:
                console.error(err);
                break;
            }
          }
        }
      })
    );
  }

  /**
   * Funzione per la gestione degli errori che vengono restituiti dal webservice
   */
  private WebServiceErrorHandler(err: V1ApiHttpErrorResponse) {
    // console.log(err);
    switch (err.errorCode) {
      case WEBSERVICE_SESSION_EXPIRED:
      case WEBSERVICE_UNAUTHORIZED:
      case WEBSERVICE_TOKEN_ERROR:
        this.store$.dispatch(AuthActions.Logout());
        break;
      case WEBSERVICE_APP_VERSION_ERROR:
        this.updateAppHandler().then();
        break;
      case WEBSERVICE_GENERIC_ERROR:
      default:
        this.notificationService.danger(err.message, 3000);
        if (!ENV.production) {
          console.log(err);
        }

        // Qui il report error non dovrebbe essere eseguito in quanto gli errori
        // del webservice vengono gia memorizzati in automatico sul server
        // this.errorReportService.sendErrorToApi$(error).toPromise();
        break;
    }
  }

  private async updateAppHandler() {
    let message = 'Attenzione per continuare ad utilizzare l\'app è necessario aggiornare all\'ultima versione disponibile!.';
    const alert = await this.alertController.create({
      translucent: true,
      backdropDismiss: false,
      header: 'Aggiornamento Disponibile',
      message,
      buttons: ['OK']
    });
    await alert.present();
    this.store$.dispatch(AuthActions.Logout());
    const res = await alert.onWillDismiss();
    window.location.reload();
  }

}
